import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { ArrayUtil, ObjectUtil, StringUtil } from 'src/utils';

interface CaseWorklogDTO {
  id: string;
  timeIn:  moment.Moment | null;
  timeOut:  moment.Moment | null;
  totalTime: string;
  assignedTo: string;
  comment: string;
}
const CaseWorklogDTO = {
  create: (initValues?: Partial<CaseWorklogDTO>): CaseWorklogDTO => {
    const defaults: CaseWorklogDTO = {
      id: '',
      timeIn: null,
      timeOut: null,
      totalTime: '',
      assignedTo: '',
      comment: '',
    };
    const fixedInitValues: Partial<CaseWorklogDTO> = initValues != null
      ? {
        id: StringUtil.IsNullOrEmpty(initValues.id) ? uuidv4() : initValues.id,
        timeIn: ObjectUtil.ToMoment(initValues.timeIn),
        timeOut: ObjectUtil.ToMoment(initValues.timeOut),
      }
      : {};
    return { ...defaults, ...initValues, ...fixedInitValues };
  },
};

export default CaseWorklogDTO;